import React from 'react';
import Header from '../../views/Header';
import MyDrawingSection from './MyDrawingSection';
import PeoplesDrawingSection from './PeoplesDrawingSection';
function DrawingHome(props) {
    return (
        <div>
            <Header/>
            <MyDrawingSection/>
            <PeoplesDrawingSection/>
        </div>
    );
}

export default DrawingHome;